import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Documentation from "@/pages/Documentation";
import Agents from "@/pages/Agents";
import AgentEditor from "@/pages/AgentEditor";
import Skills from "@/pages/Skills";
import Connections from "@/pages/Connections";
import Documents from "@/pages/Documents";
import Providers from "@/pages/Providers";
import Studio from "@/pages/Studio";
import Conversations from "@/pages/Conversations";
import ConversationDetail from "@/pages/ConversationDetail";
import Quality from "@/pages/Quality";
import Telephony from "@/pages/Telephony";
import Settings from "@/pages/Settings";
import Costs from "@/pages/Costs";
import Architect from "@/pages/Architect";

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/agents/:id" element={<AgentEditor />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/connexions" element={<Connections />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/fournisseurs" element={<Providers />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/historique" element={<Conversations />} />
            <Route path="/historique/:id" element={<ConversationDetail />} />
            <Route path="/qualite" element={<Quality />} />
            <Route path="/telephonie" element={<Telephony />} />
            <Route path="/parametres" element={<Settings />} />
            <Route path="/couts" element={<Costs />} />
            <Route path="/architecte" element={<Architect />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

